
import { Component, Prop, Vue } from 'vue-property-decorator';
import { reportContentCategoriesApi } from '@/apis';
import OsDatatable from '@/components/core/OsDatatable.vue';
import { IExtendedDataTableHeader } from '@/models/core';
import {
  ILink,
  IReportContentCategory,
  ReportContentCategoryState
} from '@/models/application';
import OsCard from '@/components/core/card/OsCard.vue';
import OsCardText from '@/components/core/card/OsCardText.vue';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import OsTestReportForm from '@/components/shared/reports/OsTestReportForm.vue';

@Component({
  components: {
    OsTestReportForm,
    OsSheetContent,
    OsSheet,
    OsCardText,
    OsCard,
    OsDatatable
  }
})
export default class OsReportContentCategoriesOverview extends Vue {
  @Prop({ default: 'Report content categories' })
  textHeader!: string;

  reportContentCategories: IReportContentCategory[] = [];
  isInReorderMode = false;

  get extraButtons() {
    if (this.isInReorderMode) {
      return [
        {
          title: 'CANCEL',
          icon: 'mdi-cancel',
          enabled: true,
          action: async () => {
            this.isInReorderMode = false;
            await this.loadData();
          }
        },
        {
          title: 'SAVE',
          icon: 'mdi-check',
          enabled: true,
          action: async () => {
            for (const c of this.reportContentCategories) {
              await reportContentCategoriesApi.update(c);
            }

            await this.loadData();

            this.isInReorderMode = false;
          }
        }
      ];
    }

    return [
      {
        title: 'Change order',
        icon: 'mdi-sort',
        enabled: true,
        action: async () => {
          await this.loadData();
          this.isInReorderMode = true;

          this.orderedBySequencenumber.forEach((item, index) => {
            item.sequencenumber = index + 1;
          });
        }
      }
    ];
  }

  get orderedBySequencenumber() {
    return this.reportContentCategories.sort(
      (a, b) => a.sequencenumber - b.sequencenumber
    );
  }

  get header(): IExtendedDataTableHeader[] {
    if (this.isInReorderMode) {
      return [
        {
          text: 'Name',
          value: 'name',
          sortable: false
        },
        {
          text: '',
          value: 'id',
          icon: 'mdi-arrow-up',
          width: '15px',
          sortable: false,
          action: (l: IReportContentCategory) => {
            const index = this.reportContentCategories.indexOf(l);

            this.reportContentCategories[index].sequencenumber--;
            this.reportContentCategories[index - 1].sequencenumber++;
          },
          visible: (l: IReportContentCategory) => {
            return l.sequencenumber > 1;
          },
          align: 'center'
        },
        {
          text: '',
          value: 'id',
          icon: 'mdi-arrow-down',
          width: '15px',
          sortable: false,
          action: async (l: IReportContentCategory) => {
            const index = this.reportContentCategories.indexOf(l);

            this.reportContentCategories[index].sequencenumber++;
            this.reportContentCategories[index + 1].sequencenumber--;
          },
          visible: (l: IReportContentCategory) => {
            return l.sequencenumber < this.reportContentCategories.length;
          },
          align: 'center'
        }
      ];
    }

    return [
      {
        text: 'Name',
        value: 'name',
        sortable: false
      },
      {
        text: 'Order',
        width: '100px',
        value: 'sequencenumber',
        sortable: false
      },
      {
        text: 'Status',
        width: '100px',
        value: 'state',
        sortable: false
      }
    ];
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.reportContentCategories =
      await reportContentCategoriesApi.getReportContentCategories();
  }
}
